import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { QueryComments } from './querycomments';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class QuerycommentsService {

  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {
  }

  Getquerytree(requesttypeid: string, requestdetailid: string): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + '/api/QueryCommentsApi/Getquerytree/' + requesttypeid + '/' + requestdetailid);
  }
 
  Get(): Observable<QueryComments[]> {
    return this.httpClient.get<QueryComments[]>(this.baseUrl + '/api/QueryCommentsApi')
  }
  GetImage(filename: string): Observable<any> {
    return this.httpClient.post(this.baseUrl + 'api/UserApi/GetIcon/' + filename, { observe: 'response' });
  }
  Post(query: QueryComments): Observable<any> {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + '/api/QueryCommentsApi/add', query, { headers: header, observe: 'response' })
  }
  Delete(query: QueryComments) {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + '/api/QueryCommentsApi/activeordeactive', query, { headers: header, observe: 'response' })
  }
  Put(query: QueryComments): Observable<any> {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.put(this.baseUrl + '/api/QueryCommentsApi/Update', query, { headers: header, observe: 'response' })
  }

}

